<template>
  <div class="base-content-wrapper">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.base-content-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
}
</style>